
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import './index.css'
import { connect } from 'react-redux'
import getProp from '@f/get-prop'
import { warehouseSetupSelectConnectTab, fetchBillingByWorkspaceSlugIfNeeded } from 'actions'
import { getWarehouseMetadataById, getBillingPlan } from 'selectors'
import { FlexGrid, FlexItem } from 'ui/flexgrid'
import Space from 'ui/Space'
import Link from 'ui/Link'
import ConnectExistingDatabase from '../../components/connect-existing-database'
import Form from '../warehouse-setup-connect-form'
import { isMtuBusinessPlan } from 'lib/utils/billing-plans'

class WarehouseSetupConnect extends Component {
  render () {
    const name = getProp('database.name', this.props)

    return (
      <FlexGrid justifyContent='center'>
        <FlexItem width='700'>
          <div className='WarehouseSetupConnect'>
            <h1>Connect to {name}</h1>
            <Space value={14} />
            <p>If you don’t already have a database, you can <Link href='https://segment.com/docs/warehouses/' rel='external'>follow our guides to setup a new database</Link></p>
            <Space value={28} />
            <ConnectExistingDatabase metadataSlug={this.props.database.slug}>
              <Form databaseId={this.props.databaseId} workspaceSlug={this.props.workspaceSlug} />
            </ConnectExistingDatabase>
          </div>
        </FlexItem>
      </FlexGrid>
    )
  }

  componentDidMount () {
    this.props.fetchBilling()
  }
}

function mapStateToProps (state, ownProps) {
  const { workspaceSlug } = ownProps
  const {
    databaseId,
    connectTab
  } = state.application.warehouseSetup

  const { hasRequested, didRequestFail } = state.billingByWorkspaceSlug[workspaceSlug] || {}
  let billingPlanId = null
  if (hasRequested && !didRequestFail) {
    const plan = getBillingPlan(state, workspaceSlug) || {}
    billingPlanId = plan.id
  }

  const database = getWarehouseMetadataById(state, databaseId) || {}
  return {
    // app
    databaseId,
    selectedTabId: connectTab,
    // data
    database,
    isBusinessPlan: isMtuBusinessPlan(billingPlanId)
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    selectTab: tab => dispatch(warehouseSetupSelectConnectTab(tab)),
    fetchBilling: () => dispatch(fetchBillingByWorkspaceSlugIfNeeded(ownProps.workspaceSlug))
  }
}

WarehouseSetupConnect.propTypes = {
  database: PropTypes.object.isRequired,
  databaseId: PropTypes.string.isRequired,
  fetchBilling: PropTypes.func.isRequired,
  workspaceSlug: PropTypes.string.isRequired
}

WarehouseSetupConnect.displayName = 'WarehouseSetupConnect'

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseSetupConnect)



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/containers/warehouse-setup-connect/index.js